import * as React from "react";
import { sortItems } from "../infinite-utils/infinite-utils-sort";
import { ISortHOCProps } from "../infinite-interface";

export class SortHOC extends React.PureComponent<ISortHOCProps, any> {
    render() {
        return this.props.children(this.sortItems());
    }

    private sortItems() {
        const { items, sortKey, sortDirection, sortType } = this.props;
        if (!items || !sortKey || sortKey[0] === "") {
            return items;
        }
        return sortItems(items, sortKey, sortDirection, sortType);
    }
}
